import React, { useEffect, useRef, useState } from "react";
import { JobSearch, post } from "../../config/imagesLink";
import { ShimmerThumbnail } from "react-shimmer-effects";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import JobAction from "./JobAction";
import axios from "../../API/axios";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ModalForGuest from "../ModalForGuest";
import { JobCardSkeleton } from "@skeleton";
import JobApply from "./JobApply";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import BookmarkSharpIcon from "@mui/icons-material/BookmarkSharp";
import { useTranslation } from "react-i18next";
const JobList = ({
  reset,
  filterJobList,
  setReset,
  jobsList,
  setJobsList,
  getAllJobList,
  totalPages,
  setTotalPages,
  page,
  setSearchValue,
  searchValue,
  isLoading,
  isError,
  hasMoreData,
  nextBatchLoading,
  refContainer,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const userUid = localStorage.getItem("userUid");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [bookmarkModal, setBookmarkModal] = useState(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };

  //************************Save job End  ************************//
  const [savedJobs, setSavedJobs] = useState(new Set());

  const saveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        console.log("save post", res);
        setToastMessage(res.data.message);
        setShowToast(true);
        setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save job End  ************************//

  //************************UnSave job start  ************************//
  const unsaveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(false);
        setSavedJobs((prev) => {
          const newSavedJobs = new Set(prev);
          newSavedJobs.delete(jobId);
          return newSavedJobs;
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnSave job End  ************************//

  //************************Apply and Unapply job  ************************//
  const [isappliedF, setIsappliedF] = useState(false);
  const [appliedId, setAppliedId] = useState("");
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleCloseModal = () => setShowAppliedModal(false);
  const handleShow = () => setShowAppliedModal(true);
  const [appliedJobId, setAppliedJobId] = useState("");

  //************************Apply and Unapply job  ************************//

  //************************User Profile Stats Start  ************************//
  // const [userPer, setUserPer] = useState([]);
  // const getUserProfilePer = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`UserProfile/GetProfilePercentage`, data)
  //     .then((response) => {
  //       // console.log("userprofilestat", response.data.responseData);
  //       const res = response.data.responseData;
  //       setUserPer(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getUserProfilePer();
  // }, [sessionId]);

  const [profileConfig, setProfileConfig] = useState([]);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const userConfig = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("User/GetUserConfig", data).then((resData) => {
        // console.log('configgggg', resData.data.responseData);
        setProfileConfig(resData.data.responseData);
      });
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        setUnauthorisedModal(true);
      }
    }
  };

  console.log("configgggg", profileConfig);


  const [showResumeModal, setShowResumeModal] = useState(false);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    if (sessionId) {
      (async () => {
        await Promise.all([
          userConfig(),
        ]);
      })();
    }
  }, []);

  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************User Profile Stats End  ************************//

  useEffect(() => {
    if (showAppliedModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showAppliedModal]);

  // console.log("jobsList", jobsList);

  // .................................shortDescription
  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const anchors = div.querySelectorAll('a');
    anchors.forEach(anchor => {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    });

    return div.innerHTML;
  };


  const linkifyContent = (htmlContent) => {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };


  const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      if ((index + 1) % 12 === 0) {
        result.push({ isAd: true });
      }
    });
    return result;
  };
  const postsWithAds = getPostListWithAds(jobsList);
  const postsWithAdsF = getPostListWithAds(filterJobList);


  
  const adInitialized = useRef(false);
       useEffect(() => {
          // Dynamically add the adsbygoogle script
          const script = document.createElement("script");
          script.async = true;
          script.src =
              "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113";
          script.crossOrigin = "anonymous";
          document.body.appendChild(script);
  
          // Initialize the ad
          if (!adInitialized.current) {
              window.adsbygoogle = window.adsbygoogle || [];
              window.adsbygoogle.push({});
              adInitialized.current = true;
          }
  
          // Add event listener to open ads in a new tab
          const handleAdClick = (event) => {
              const target = event.target;
              if (target.tagName === "A" && !target.hasAttribute("target")) {
                  target.setAttribute("target", "_blank");
              }
          };
  
          // Attach listener to the entire document for dynamic ads
          document.addEventListener("click", handleAdClick);
  
          return () => {
              // Cleanup script and listener on component unmount
              document.body.removeChild(script);
              document.removeEventListener("click", handleAdClick);
          };
      }, []); 
  
      
  return (
    <>
      <div className="row job-header">
        <div className="col-md-12 ">
          <div className="search-container ">
            <SearchSharpIcon className="material-symbols-sharp" />
            <div className="search-input-container">
              <input
                type="text"
                // value={inputValue}
                // onChange={handleInputChange}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                value={searchValue}
                placeholder={t("SearchJob.Search")}
                className="search-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="row"
        id="job-list-container"
        ref={refContainer}
        style={{
          overflowY: "auto",
          flex: 1,
          minHeight: "400px",
          display: "flex",
          flexWrap: "wrap",
          alignContent: "flex-start",
        }}
      >
        {isLoading ? (
          <JobCardSkeleton count={3} />
        ) : isError  ? (
          <div className="mt-2 error-image-cont error-image-job">
            <img src={post.errorSmall} alt="404 Not Found" width={200} />
          </div>
        // ) : 
        // jobsList?.length === 0 ? (
        // ) : jobsList?.length === 0 && searchValue?.trim() !== "" ? (
        //   <div className="mt-2 error-image-cont error-image-job">
        //     <img src={post.errorSmall} alt="No Jobs Found" width={200} />
        //   </div>
        ) : reset === false ? (
          // jobsList &&
          // jobsList
          //   .filter((item) => !item.isDeleted)
          //   ?.map((item, index) => {
          // const now = moment();
          // const itemTime = moment.utc(item?.creationTime);
          // const duration = moment.duration(now.diff(itemTime));

          // const years = duration.years();
          // const months = duration.months();
          // const days = duration.days();
          // const hours = duration.hours();
          // const minutes = duration.minutes();

          // let result = "";

          // if (years > 0) {
          //   result = `${years} year${years > 1 ? "s" : ""} ago`;
          // } else if (months > 0) {
          //   result = `${months} month${months > 1 ? "s" : ""} ago`;
          // } else if (days > 0) {
          //   result = `${days} day${days > 1 ? "s" : ""} ago`;
          // } else if (hours > 0) {
          //   result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
          // } else if (minutes > 0) {
          //   result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
          // } else {
          //   result = "just now";
          // }
          //     return (
          // <div className="col-md-4 d-flex align-items-stretch mt-4">
          //   <div className="jobCard p-3 w-100 d-flex flex-column justify-content-between">
          //     <div>
          //       <div
          //         className="d-flex justify-content-start align-items-center"
          //         style={{ height: "60px" }}
          //       >
          //         <Link to={`/Company/${item.compUid}`}>
          //           <div className="pointer me-2 d-flex">
          //             <img
          //               src={item?.compLogo}
          //               alt=""
          //               width={50}
          //               height={50}
          //               style={{ borderRadius: "50px" }}
          //             />
          //           </div>
          //         </Link>
          //         <Link to={`/Company/${item.compUid}`}>
          //           <span className="f-14 f-700 job-company-name">
          //             {item.compName}
          //           </span>
          //         </Link>
          //         <div className="ml-auto">
          //           <JobAction
          //             item={item}
          //             AllJobList={getAllJobList}
          //             setJobList={setJobsList}
          //             jobList={jobsList}
          //             totalPages={totalPages}
          //             setTotalPages={setTotalPages}
          //             page={page}
          //           />
          //         </div>
          //       </div>

          //       <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
          //         <Link to={`/JobDetail/${item.jobId}`}>
          //           <p className="job-title f-16 fw-bold pointer">
          //             {/* {item.title.length > 10
          //             ? `${item.title.substring(0, 10)}...`
          //             : item.title} */}
          //             {item.title}
          //           </p>
          //         </Link>

          //         {savedJobs.has(item?.jobId) || item?.isSaved === true ? (
          //           <div className="d-flex align-items-center postAction">
          //             <BookmarkSharpIcon
          //               className="material-symbols-sharp pointer"
          //               onClick={() => {
          //                 if (guestModeData !== "true") {
          //                   unsaveJob(item?.jobId);
          //                 }
          //               }}
          //               disabled={guestModeData === "true"}
          //             />
          //           </div>
          //         ) : (
          //           <div className="d-flex align-items-center postAction">
          //             <BookmarkBorderSharpIcon
          //               className="material-symbols-outlined pointer"
          //               onClick={() => {
          //                 if (guestModeData !== "true") {
          //                   saveJob(item?.jobId);
          //                 }
          //               }}
          //               disabled={guestModeData === "true"}
          //             />
          //           </div>
          //         )}
          //       </div>

          //       <div
          //         dangerouslySetInnerHTML={{
          //           __html: cleanShortDescription(
          //             item.shortDescription.length > 50
          //               ? item.shortDescription.slice(0, 50) + "..."
          //               : item.shortDescription
          //           ),
          //         }}
          //         style={{ fontSize: "12px", lineHeight: "1.5" }}
          //       />
          //       <h6 className="f-10 mt-1">{item.cityName}</h6>

          //       <div className="d-flex justify-content-between align-items-center mt-1 job-card-post-date">
          //         <small className="f-8">Posted {result}</small>
          //         <div className="badge badge-date">
          //           {item?.expiringInDays} days Left
          //         </div>
          //       </div>

          //       <div className="jobType mt-2 mb-3">
          //         <div className="badge badge-job me-3 mb-1">
          //           {item.jbTypName}
          //         </div>
          //         <div className="badge badge-job me-3 mb-1">
          //           {item.workLocationTypeName}
          //         </div>
          //         <div className="badge badge-job mb-1">
          //           {item.designationName}
          //         </div>
          //       </div>
          //     </div>
          //     <div>
          //       <div className=" mt-3" ></div>
          //       <JobApply
          //         isAppliedByYou={item?.isApplied}
          //         jobId={item?.jobId}
          //         getAllJobList={getAllJobList}
          //         item={item}
          //         profileConfig={profileConfig}
          //         // userPer={userPer}
          //         AddUserCcv={AddUserCcv}
          //         userCcv={userCcv}
          //       />
          //     </div>
          //   </div>
          // </div>
          //     );
          //   })
          <>
            {postsWithAds
              ?.filter((item) => !item.isDeleted)
              .map((item, index) => {
                const now = moment();
                const itemTime = moment.utc(item?.creationTime);
                const duration = moment.duration(now.diff(itemTime));

                const years = duration.years();
                const months = duration.months();
                const days = duration.days();
                const hours = duration.hours();
                const minutes = duration.minutes();

                let result = '';
 
                 if (years > 0) {
                  result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (months > 0) {
                  result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (days > 0) {
                  result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (hours > 0) {
                  result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (minutes > 0) {
                  result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else {
                  result = t("Notifications.Just Now");
                }

                return (
                  <React.Fragment key={`post-${index}`}>
                    {item.isAd && (
                      <div className="advertiseImage mt-4">
                        <div className="advertisementview">
                          <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px",
                            overflow: "hidden",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                          }}>
                            <ins className="adsbygoogle"
                              style={{
                                display: "block",
                                width: "100%",
                                height: "100%", // Ensure it fits the container
                                // maxWidth: "320px",
                                // minHeight: "50px",
                                margin: "0 auto",
                              }}
                              data-ad-client="ca-pub-8691062301030113"
                              data-ad-slot="9135916775"
                              // data-ad-format="auto"
                              data-adtest="on"
                              data-full-width-responsive="true"></ins>
                          </div>
                          {/* <h1 className="adText">Advertisement</h1> */}
                        </div>

                      </div>
                    )}

                    {!item.isAd && (
                      <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard">
                        <div className="jobCard p-3 w-100 d-flex flex-column justify-content-between">
                          <div>
                            <div
                              className="d-flex justify-content-start align-items-center"
                              style={{ height: "60px" }}
                            >
                          <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                              {/* <Link to={`/Company/${item.compUid}`}> */}
                                <div className="pointer me-2 d-flex">
                                  <img
                                    src={item?.compLogo}
                                    alt=""
                                    width={50}
                                    height={50}
                                    style={{ borderRadius: "50px" }}
                                  />
                                </div>
                              </Link>
                              <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                                <span className="f-14 f-700 job-company-name">
                                  {item.compName}
                                </span>
                              </Link>
                              <div className="ml-auto">
                                <JobAction
                                  item={item}
                                  AllJobList={getAllJobList}
                                  setJobList={setJobsList}
                                  jobList={jobsList}
                                  totalPages={totalPages}
                                  setTotalPages={setTotalPages}
                                  page={page}
                                />
                              </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
                              <Link to={`/JobDetail/${item.jobId}`}>
                                <p className="job-title f-16 fw-bold pointer">
                                  {/* {item.title.length > 10
                                                      ? `${item.title.substring(0, 10)}...`
                                                      : item.title} */}
                                  {item.title}
                                </p>
                              </Link>

                              {savedJobs.has(item?.jobId) || item?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>

                            <p
                              className="short-Des-jobCard fst-italic"
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  item.shortDescription?.length > 50
                                    ? item.shortDescription?.slice(0, 50) + "..."
                                    : item.shortDescription
                                ),
                              }}
                              style={{ fontSize: "12px", lineHeight: "1.5" }}
                            />
                            <h6 className="f-10 mt-1">{item.cityName}</h6>

                            <div className="d-flex justify-content-between align-items-center mt-1 job-card-post-date">
                              <small className="f-8">{t("Manage Job.Posted")} {result}</small>
                              <div className="badge badge-date">
                               {Number(item?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(item?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${item?.expiringInDays} ${t("Manage Job.days Left")}`}
                              </div>
                            </div>

                            <div className="jobType mt-2 mb-3">
                              <div className="badge badge-job me-3 mb-1">
                                {item.jbTypName}
                              </div>
                              <div className="badge badge-job me-3 mb-1">
                                {item.workLocationTypeName}
                              </div>
                              <div className="badge badge-job mb-1">
                                {item.designationName}
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className=" mt-3" ></div>
                            <JobApply
                              isAppliedByYou={item?.isApplied}
                              jobId={item?.jobId}
                              getAllJobList={getAllJobList}
                              item={item}
                              profileConfig={profileConfig}
                              // userPer={userPer}
                              AddUserCcv={AddUserCcv}
                              userCcv={userCcv}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </>

        ) : (
          // filterJobList &&
          // filterJobList
          //   .filter((item) => !item.isDeleted)
          //   ?.map((item, index) => {
          //     const now = moment();
          //     const itemTime = moment.utc(item?.creationTime);
          //     const duration = moment.duration(now.diff(itemTime));

          //     const years = duration.years();
          //     const months = duration.months();
          //     const days = duration.days();
          //     const hours = duration.hours();
          //     const minutes = duration.minutes();

          //     let result = "";

          //     if (years > 0) {
          //       result = `${years} year${years > 1 ? "s" : ""} ago`;
          //     } else if (months > 0) {
          //       result = `${months} month${months > 1 ? "s" : ""} ago`;
          //     } else if (days > 0) {
          //       result = `${days} day${days > 1 ? "s" : ""} ago`;
          //     } else if (hours > 0) {
          //       result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
          //     } else if (minutes > 0) {
          //       result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
          //     } else {
          //       result = "just now";
          //     }
          //     return (
          //       <div className="col-md-4 d-flex align-items-stretch mt-4">
          //         <div className="jobCard p-3 w-100 d-flex flex-column">
          //           <div
          //             className="d-flex justify-content-start align-items-center"
          //             style={{ height: "60px" }}
          //           >
          //             <Link to={`/Company/${item.compUid}`}>
          //               <div className="pointer me-2">
          //                 <img
          //                   src={item?.compLogo}
          //                   alt=""
          //                   width={50}
          //                   height={50}
          //                   style={{ borderRadius: "50px" }}
          //                 />
          //               </div>
          //             </Link>
          //             <Link to={`/Company/${item.compUid}`}>
          //               <span className="f-14 f-700 job-company-name">
          //                 {item.compName}
          //               </span>
          //             </Link>
          //             <div className="ml-auto">
          //               <JobAction
          //                 item={item}
          //                 AllJobList={getAllJobList}
          //                 setJobList={setJobsList}
          //                 jobList={jobsList}
          //                 totalPages={totalPages}
          //                 setTotalPages={setTotalPages}
          //                 page={page}
          //               />
          //             </div>
          //           </div>

          //           <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
          //             <Link to={`/JobDetail/${item.jobId}`}>
          //               <p className="f-16 fw-bold pointer">
          //                 {/* {item.title.length > 10
          //                   ? `${item.title.substring(0, 10)}...`
          //                   : item.title} */}
          //                 {item.title}
          //               </p>
          //             </Link>

          //             {savedJobs.has(item?.jobId) || item?.isSaved === true ? (
          //               <div className="d-flex align-items-center postAction">
          //                 {/* <span
          //                   className="material-symbols-sharp pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       unsaveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 >
          //                   bookmark
          //                 </span> */}
          //                 <BookmarkSharpIcon
          //                   className="material-symbols-sharp pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       unsaveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 />
          //               </div>
          //             ) : (
          //               <div className="d-flex align-items-center postAction">
          //                 {/* <span
          //                   className="material-symbols-outlined pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       saveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 >
          //                   bookmark
          //                 </span> */}
          //                 <BookmarkBorderSharpIcon
          //                   className="material-symbols-outlined pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       saveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 />
          //               </div>
          //             )}
          //           </div>

          //           <p className="f-14">
          //             {/* {item.shortDescription.length > 15
          //               ? `${item.shortDescription.substring(0, 15)}...`
          //               : item.shortDescription} */}
          //             {item.shortDescription}
          //           </p>
          //           <h6 className="f-10 mt-1">{item.cityName}</h6>

          //           <div className="d-flex justify-content-between align-items-center mt-1 job-card-post-date">
          //             <small className="f-8">Posted {result}</small>
          //             <div className="badge badge-date">
          //               {item?.expiringInDays} days Left
          //             </div>
          //           </div>

          //           <div className="jobType mt-2 mb-3">
          //             <div className="badge badge-job me-3 mb-1">
          //               {item.jbTypName}
          //             </div>
          //             <div className="badge badge-job me-3 mb-1">
          //               {item.workLocationTypeName}
          //             </div>
          //             <div className="badge badge-job mb-1">
          //               {item.designationName}
          //             </div>
          //           </div>

          //           <JobApply
          //             isAppliedByYou={item?.isApplied}
          //             jobId={item?.jobId}
          //             getAllJobList={getAllJobList}
          //             item={item}
          //             profileConfig={profileConfig}
          //             // userPer={userPer}
          //             AddUserCcv={AddUserCcv}
          //             userCcv={userCcv}
          //           />
          //         </div>
          //       </div>
          //     );
          //   })

          <>
            {postsWithAdsF
              ?.filter((item) => !item.isDeleted)
              .map((item, index) => {
                const now = moment();
                const itemTime = moment.utc(item?.creationTime);
                const duration = moment.duration(now.diff(itemTime));

                const years = duration.years();
                const months = duration.months();
                const days = duration.days();
                const hours = duration.hours();
                const minutes = duration.minutes();

                let result = "";

                if (years > 0) {
                  result = `${years} year${years > 1 ? "s" : ""} ago`;
                } else if (months > 0) {
                  result = `${months} month${months > 1 ? "s" : ""} ago`;
                } else if (days > 0) {
                  result = `${days} day${days > 1 ? "s" : ""} ago`;
                } else if (hours > 0) {
                  result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
                } else if (minutes > 0) {
                  result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
                } else {
                  result = "just now";
                }

                return (
                  <React.Fragment key={`post-${index}`}>
                    {item.isAd && (
                      <div className="advertiseImage mt-4">
                        <div className="advertisementview">
                          <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px",
                            overflow: "hidden",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                          }}>
                            <ins className="adsbygoogle"
                              style={{
                                display: "block",
                                width: "100%",
                                height: "100%", // Ensure it fits the container
                                // maxWidth: "320px",
                                // minHeight: "50px",
                                margin: "0 auto",
                              }}
                              data-ad-client="ca-pub-8691062301030113"
                              data-ad-slot="9135916775"
                              // data-ad-format="auto"
                              data-adtest="on"
                              data-full-width-responsive="true"></ins>
                          </div>
                          {/* <h1 className="adText">Advertisement</h1> */}
                        </div>

                      </div>
                    )}

                    {!item.isAd && (
                      <div className="col-md-4 d-flex align-items-stretch mt-4">
                        <div className="jobCard p-3 w-100 d-flex flex-column">
                          <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ height: "60px" }}
                          >
                       <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                            {/* <Link to={`/Company/${item.compUid}`}> */}
                              <div className="pointer me-2">
                                <img
                                  src={item?.compLogo}
                                  alt=""
                                  width={50}
                                  height={50}
                                  style={{ borderRadius: "50px" }}
                                />
                              </div>
                            </Link>
                            <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                              <span className="f-14 f-700 job-company-name">
                                {item.compName}
                              </span>
                            </Link>
                            <div className="ml-auto">
                              <JobAction
                                item={item}
                                AllJobList={getAllJobList}
                                setJobList={setJobsList}
                                jobList={jobsList}
                                totalPages={totalPages}
                                setTotalPages={setTotalPages}
                                page={page}
                              />
                            </div>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
                            <Link to={`/JobDetail/${item.jobId}`}>
                              <p className="f-16 fw-bold pointer">
                                {/* {item.title.length > 10
                                                        ? `${item.title.substring(0, 10)}...`
                                                        : item.title} */}
                                {item.title}
                              </p>
                            </Link>

                            {savedJobs.has(item?.jobId) || item?.isSaved === true ? (
                              <div className="d-flex align-items-center postAction">
                                {/* <span
                                                        className="material-symbols-sharp pointer"
                                                        onClick={() => {
                                                          if (guestModeData !== "true") {
                                                            unsaveJob(item?.jobId);
                                                          }
                                                        }}
                                                        disabled={guestModeData === "true"}
                                                      >
                                                        bookmark
                                                      </span> */}
                                <BookmarkSharpIcon
                                  className="material-symbols-sharp pointer"
                                  onClick={() => {
                                    if (guestModeData !== "true") {
                                      unsaveJob(item?.jobId);
                                    }
                                  }}
                                  disabled={guestModeData === "true"}
                                />
                              </div>
                            ) : (
                              <div className="d-flex align-items-center postAction">
                                {/* <span
                                                        className="material-symbols-outlined pointer"
                                                        onClick={() => {
                                                          if (guestModeData !== "true") {
                                                            saveJob(item?.jobId);
                                                          }
                                                        }}
                                                        disabled={guestModeData === "true"}
                                                      >
                                                        bookmark
                                                      </span> */}
                                <BookmarkBorderSharpIcon
                                  className="material-symbols-outlined pointer"
                                  onClick={() => {
                                    if (guestModeData !== "true") {
                                      saveJob(item?.jobId);
                                    }
                                  }}
                                  disabled={guestModeData === "true"}
                                />
                              </div>
                            )}
                          </div>

                          <p className="f-14">
                            {/* {item.shortDescription.length > 15
                                                    ? `${item.shortDescription.substring(0, 15)}...`
                                                    : item.shortDescription} */}
                            {item.shortDescription}
                          </p>
                          <h6 className="f-10 mt-1">{item.cityName}</h6>

                          <div className="d-flex justify-content-between align-items-center mt-1 job-card-post-date">
                            <small className="f-8">{t("Manage Job.Posted")} {result}</small>
                            <div className="badge badge-date">
                             {Number(item?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(item?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${item?.expiringInDays} ${t("Manage Job.days Left")}`}
                            </div>
                          </div>

                          <div className="jobType mt-2 mb-3">
                            <div className="badge badge-job me-3 mb-1">
                              {item.jbTypName}
                            </div>
                            <div className="badge badge-job me-3 mb-1">
                              {item.workLocationTypeName}
                            </div>
                            <div className="badge badge-job mb-1">
                              {item.designationName}
                            </div>
                          </div>

                          <JobApply
                            isAppliedByYou={item?.isApplied}
                            jobId={item?.jobId}
                            getAllJobList={getAllJobList}
                            item={item}
                            profileConfig={profileConfig}
                            // userPer={userPer}
                            AddUserCcv={AddUserCcv}
                            userCcv={userCcv}
                          />
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </>
        )}

        {nextBatchLoading && hasMoreData && (
          <div className="text-center my-3">
            <img src={post?.loader} width={50} />
          </div>
        )}
        {!hasMoreData && jobsList.length > 12  && (
          <p className="text-center my-3 mb-0">{t("Newsfeed.No more data available")}</p>
        )}
         {/* {(page > 1 && !hasMoreData) &&(
                <p className="text-center my-3 mb-0">No more data available</p >
            )} */}
      </div>

      {bookmarkModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {showResumeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                 {t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}
                </h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  // onClick={() => {
                  //   userCcv !== "True" && AddUserCcv();
                  // }}
                  >
                    Manage Profile
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal);
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem("hasModalShown");
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JobList;
